import React, { Suspense, useEffect } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Spinner from '@divvy-web/skylab.spinner'

import { getEmailHashFromStorage, useAuth } from '@sputnik/auth'
import { LocalExperimentProvider, useExperiment } from '@sputnik/experiments'
import LegacyDashboard from '@sputnik/pages/Dashboard'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import CreditApplicationsDataGrid from './CreditApplicationsDataGrid'
import DashboardFooter from './DashboardFooter'
import DashboardHeader from './DashboardHeader'
import FileUploadStatusProvider from './FileUploadStatusProvider'
import styles from './styles.module.scss'

export const Dashboard = () => {
  const [getClassName] = useNameFormatter('Dashboard')
  const { email } = useAuth()
  const { track } = useWebTracking()

  const { behaviorName, isInExperiment } = useExperiment({
    experiment: 'beep-credit-application-dashboard-redesign-experiment',
    inputId: email ?? '',
    bucketingKey: 'email',
  })

  useEffect(() => {
    // only run tracking on dashboard redesign. Can remove this logic once fully lauched with redesign
    if (isInExperiment || behaviorName === 'presentedRedesignedDashboard') {
      track('se_signup__application_dashboard__presented')
    }
  }, [behaviorName, isInExperiment, track])

  if (!isInExperiment || behaviorName !== 'presentedRedesignedDashboard') {
    return <LegacyDashboard />
  }

  return (
    <Suspense fallback={<Spinner fullPage />}>
      <FileUploadStatusProvider>
        <div className={styles[getClassName('')]}>
          <DashboardHeader />
          <CreditApplicationsDataGrid />
          <DashboardFooter />
        </div>
      </FileUploadStatusProvider>
    </Suspense>
  )
}

export default () => (
  <LocalExperimentProvider
    experiment='beep-credit-application-dashboard-redesign-experiment'
    inputId={getEmailHashFromStorage() ?? ''}
  >
    <Dashboard />
  </LocalExperimentProvider>
)
